module.exports = __webpack_public_path__ + "static/media/noorder.0ad7afa0.png";